// Unpublished Work © 2022-2024 Deere & Company.

export const COURSE = 'course';
export const FACILITY = 'facility';
export const ORGANIZATION = 'organization';
